import { useEffect } from 'react';
import ToggleSwitch from '@components/common/ToggleSwitch';
import { FilterItem } from '@components/filter/FilterStyle';

/**
 * ToggleFilter - 토글 스위치 필터 컴포넌트
 *
 * @param title - 필터 타이틀
 * @param enabled - 토글 활성화 여부
 * @param onChange - 토글 변경 함수
 * @param initialValue - 초기값 (필터 초기화 시 사용, 기본값: false)
 */

interface Props {
  title: string;
  enabled: boolean;
  onChange: (value: boolean) => void;
  initialValue?: boolean;
  description?: string;
}

const ToggleFilter = ({ title, enabled, onChange, initialValue = false, description }: Props) => {
  // CustomEvent 기반 필터 초기화 리스너
  const handleReset = () => {
    onChange(initialValue);
  };

  useEffect(() => {
    window.addEventListener('reset-filter', handleReset);
    return () => window.removeEventListener('reset-filter', handleReset);
  });

  return (
    <FilterItem
      title={title}
      isFlex={true}
      description={description}
      content={<ToggleSwitch checked={enabled} onChange={onChange} />}
    />
  );
};

export default ToggleFilter;
